import {Editor} from "../../../../../../pkg/slate.js";
export const getParent = (editor, at, options) => {
  try {
    return Editor.parent(editor, at, options);
  } catch (err) {
    return;
  }
};
